export const extractVersion = (version: string | undefined): string | null => {
  const versionRegex = /^(\d+\.\d+\.\d+)/;
  const match = version?.match(versionRegex);
  return match ? match[0] : null;
};